import { DSDropdownMenuT } from '@elliemae/ds-dropdownmenu-v2';
import { MENU_ITEMS_TYPES, type DSMenuButtonT } from '@elliemae/ds-menu-button';
import { generateOptionsWithId } from '@frontend/utils';
export const ChannelOptions: DSDropdownMenuT.ItemSingleOptions[] = [
  {
    dsId: 'Banked - Retail',
    value: 'Banked - Retail',
    type: 'single',
    label: 'Retail',
  },
  {
    dsId: 'Banked - Wholesale',
    value: 'Banked - Wholesale',
    type: 'single',
    label: 'Wholesale',
  },
  {
    dsId: 'Brokered',
    value: 'Brokered',
    type: 'single',
    label: 'Brokered',
  },
  {
    dsId: 'Correspondent',
    value: 'Correspondent',
    type: 'single',
    label: 'Correspondent',
  },
];
export const PAGE_ACTIONS = {
  IMPORT: 'Import',
  EXPORT: 'Export',
  RESET_TO_ICE_PPE_DEFAULT: 'Reset to Default',
  PREVIEW: 'Preview',
  RESET_DRAFT_TO_PRODUCTION: 'Reset to Production',
};
export const PageActions =
  generateOptionsWithId<DSMenuButtonT.MenuItemInterface>([
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Import',
      value: PAGE_ACTIONS.IMPORT,
    },
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Export',
      value: PAGE_ACTIONS.EXPORT,
    },
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Reset to Default',
      value: PAGE_ACTIONS.RESET_TO_ICE_PPE_DEFAULT,
    },
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Preview',
      value: PAGE_ACTIONS.PREVIEW,
    },
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Reset to Production',
      value: PAGE_ACTIONS.RESET_DRAFT_TO_PRODUCTION,
    },
  ]);
export const WORKSPACE_SECTION_ACTIONS = {
  RENAME: 'rename',
  DELETE: 'delete',
  ADD_DETAILED: 'add-detailed',
  REORDER: 'reorder',
};
export const GenerateWorkspaceSectionActions =
  generateOptionsWithId<DSMenuButtonT.MenuItemInterface>([
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Rename Section',
      value: WORKSPACE_SECTION_ACTIONS.RENAME,
    },
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Reorder Sections',
      value: WORKSPACE_SECTION_ACTIONS.REORDER,
    },
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Delete Section',
      value: WORKSPACE_SECTION_ACTIONS.DELETE,
      wrapperStyles: { color: 'red' },
    },
  ]);
export const GenerateWorkspaceSectionActionsNoDetailed =
  generateOptionsWithId<DSMenuButtonT.MenuItemInterface>([
    {
      type: MENU_ITEMS_TYPES.ACTIVABLE_ITEM,
      label: 'Add Detailed Section',
      value: WORKSPACE_SECTION_ACTIONS.ADD_DETAILED,
    },
  ]);
